import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';

@Component({
  selector: 'edu-webinar-templates',
  templateUrl: './webinar-templates.component.html',
  imports: [RouterOutlet],
})
export class WebinarTemplatesPageComponent {
  router = inject(Router);
  route = inject(ActivatedRoute);

  onCreateWebinarTemplate() {
    this.router.navigate(['./new'], { relativeTo: this.route });
  }
}
